export default "__VITE_ASSET__6ef0eeda__"